import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Checkbox } from 'ui-components/components/checkbox/';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { Input } from 'ui-components/components/input';
import { Text, TextType } from 'ui-components/components/text';
import { noop } from 'ui-components/default-props/noop';
import { FormattedMessagePropType } from '../../../../../../prop-types/intl';
import { dangerousGoodsLegacy } from '../../../../../../services/other-shipping-options/constants';
import { dangerousGoodsClassifications } from '../../../../constants/dangerous-goods-classifications';
import { DangerousGoodsRow } from '../dangerous-goods-row';
import { messages } from './messages';
import styles from './styles.module.less';

const DEFAULT_OPTION_DATA = {
  goodsType: '',
  emergencyContact: '',
};

export const DangerousGoodsLegacy = ({
  label,
  checked = false,
  onCheck = noop,
  optionData = DEFAULT_OPTION_DATA,
  updateOption = noop,
  updateInput = noop,
}) => {
  const togglerValue = useMemo(() => {
    const goodsType = optionData?.goodsType;
    const dangerType = dangerousGoodsClassifications.find((x) => x.id === goodsType);

    return dangerType ? dangerType.label : <FormattedMessage {...messages.defaultOption} />;
  }, [optionData]);

  const onChange = (field, value, updateFn) => {
    const newValue = {
      ...optionData,
      [field]: value,
    };
    updateFn({ id: dangerousGoodsLegacy, value: newValue });
  };

  return (
    <div>
      <Checkbox checked={checked} label={label} onChange={onCheck} />
      {checked && (
        <div>
          <DangerousGoodsRow>
            <Text
              className={styles['dangerous-goods-type-field']}
              htmlFor='type-of-danger-dropdown'
              textType={TextType.Label}
              value={messages.dangerousGoodsType}
            />
            <DropdownMenu className={styles['dropdown-menu']} dropdownMenuShouldHaveWidthOfButton id='type-of-danger-dropdown'>
              <DropdownMenuToggler>{togglerValue}</DropdownMenuToggler>
              {dangerousGoodsClassifications.map((option) => (
                <DropdownMenuItem key={option.id} onClick={() => onChange('goodsType', option.id, updateOption)}>
                  {option.label}
                </DropdownMenuItem>
              ))}
            </DropdownMenu>
          </DangerousGoodsRow>
          <DangerousGoodsRow>
            <Input
              className={styles['contact-field']}
              data-testid='emergency-contanct-input'
              id='emergency-contact'
              label={
                <Text className={styles['contact-label']} element='span' textType={TextType.Label} value={messages.emergencyContact} />
              }
              onBlur={(event) => onChange('emergencyContact', event?.target?.value, updateOption)}
              onChange={(event) => onChange('emergencyContact', event?.target?.value, updateInput)}
              value={optionData.emergencyContact}
              version='version2'
            />
          </DangerousGoodsRow>
        </div>
      )}
    </div>
  );
};

DangerousGoodsLegacy.propTypes = {
  label: FormattedMessagePropType.isRequired,
  checked: PropTypes.bool,
  onCheck: PropTypes.func,
  optionData: PropTypes.object,
  updateOption: PropTypes.func,
  updateInput: PropTypes.func,
};
